import React, { Component } from 'react';
import '../../App.css';

import Modal from 'react-responsive-modal';
import request from 'request-promise-native';

import FormControl from 'react-bootstrap/lib/FormControl';
import FormGroup from 'react-bootstrap/lib/FormGroup';
import Form from 'react-bootstrap/lib/Form';
import Col from 'react-bootstrap/lib/Col';
import ControlLabel from 'react-bootstrap/lib/ControlLabel';
import Button from 'react-bootstrap/lib/Button';
import HelpBlock from "react-bootstrap/lib/HelpBlock";
import ProgressBar from "react-bootstrap/lib/ProgressBar";
import Alert from "react-bootstrap/lib/Alert";
import ValidatedFormComponent from "../ValidatedFormComponent";
import AzureTable from "../AzureTable";
import CardSub from "../subcomponents/CardSub";
import Badge from "react-bootstrap/lib/Badge";
import {createCanvas} from "canvas";
import JsBarcode from "jsbarcode";

const MOVE_DEVICE_ENDPOINT = "https://qibipay.azurewebsites.net/api/VMMove";
const GET_USERS = "https://qibipay.azurewebsites.net/api/GetUsersList"

class MoveDeviceModal extends Component {
    constructor(props) {
        /*
            Props:
             - access_code
             - open
             - onClose
             - onDeviceMoved
             - logout
             - device
        */
        super(props);

        this.state = {

            loading: false,
            success: false
        }
    }

    async submit(userId) {
            this.setState({loading: true, errors:{}, errorMessage:null});

            const options = {
                method: 'POST',
                uri: MOVE_DEVICE_ENDPOINT,
                body: {
                    access_code: this.props.access_code,
                    regId: this.props.device.regId,
                    userId
                },
                json: true,
                resolveWithFullResponse: true,
                simple: false
            };

            const response = await request(options);

            this.setState({loading: false});

            if(response.statusCode===404) {
                this.props.logout();
                return;
            }

            if(response.statusCode===400) {
                this.setState({errorMessage: response.body.msg==null ? response.body : response.body.msg});
                return;
            }

            if(response.statusCode!==200) {
                this.setState({errorMessage: 'Server error occured, please retry.'});
                return;
            }

            this.setState({
                success: true
            });

            //Success
            this.props.onDeviceMoved(this.props.device);
    }

    reset() {
        this.setState({
            loading: false,
            success: false
        });
        this.props.onClose();
    }

    render() {
        return(
            <Modal open={this.props.open} onClose={this.reset.bind(this)} styles={{
                modal: {
                }
            }} >
                <h2>Move Device</h2>

                {this.state.errorMessage!=null ? (<Alert bsStyle="danger">
                    <strong>{this.state.errorMessage}</strong>
                </Alert>) : ''}

                {this.state.loading ? (
                    <div>
                        <p>Moving device...</p>
                        <ProgressBar  active now={100}/>
                    </div>
                ) : this.state.success ? (
                    <div>
                        <p>Device moved successfully!</p>
                    </div>
                ) : (
                    <div>
                        <h4>Choose the user to transfer this device to:</h4>
                        <AzureTable
                            logout={this.props.logout}
                            access_code={this.props.access_code}
                            onLoad={() => {
                            }}
                            tableRef={(ref) => {
                                this.tableRef = ref;
                            }}
                            getTdProps={(state, rowInfo, column, instance) => {
                                if(rowInfo!=null && column.Header!=='Delete') return {
                                    style: {
                                        cursor: 'pointer'
                                    },
                                    onClick: e => {
                                        console.log("Cell - onClick", rowInfo.original);
                                        this.submit(rowInfo.original.id);
                                    }
                                };
                                return {};
                            }}
                            functionUrl={GET_USERS}
                            defaultSorted={[
                                {
                                    id: "username",
                                    desc: false
                                }
                            ]}
                            columns={[
                                {
                                    Header: "Username",
                                    accessor: "username",
                                    filterable: true,
                                },
                                {
                                    Header: "E-mail",
                                    accessor: "email",
                                    filterable: true,
                                    sortable: false
                                }
                            ]}
                            filterable
                            defaultPageSize={10}
                            className="-striped -highlight"
                            pageSize={10}
                        />
                    </div>
                )}
            </Modal>
        );
    }

}

export default MoveDeviceModal;